import { Box, Grid } from '@mui/material';
import Searchbar from '../../components/Support_New/Searchbar';
import SupportLeftContainer from '../../components/Support_New/SupportLeftContainer';
import SupportRightContainer from '../../components/Support_New/SupportRightContainer';
import { useSupport } from '../../providers/SupportProvider';
import NoDataFound from '../../components/Support_New/NoUserFound';
import FilterPage from './FilterPage';
import CustomerLoadingPage from './CustomerLoadingPage';

export enum SupportStep {
  ACCOUNT = 'ACCOUNT',
  KYC = 'KYC',
  APPLICATIONS = 'APPLICATIONS',
  USER_AUDIT = 'USER_AUDIT',
}

export const supportStepOptions = [
  'ACCOUNT',
  'KYC',
  'APPLICATIONS',
  'USER_AUDIT',
];

const Support = () => {
  const { filter, filteredCustomer, loading, isEmptyFilter } = useSupport();
  console.log('filteredCustomer', filteredCustomer);

  return (
    <>
      {isEmptyFilter ? (
        <FilterPage />
      ) : (
        <>
          <Searchbar />
          <Box
            sx={{
              height: 'calc(100vh - 165px)',
              p: 2.5,
              overflow: 'auto',
            }}
          >
            {!filteredCustomer ? (
              <NoDataFound text="User does not exist" />
            ) : loading ? (
              <CustomerLoadingPage />
            ) : (
              <Grid sx={{ height: '100%' }} container spacing={2}>
                <Grid
                  // sx={{ height: '100%' }}
                  item
                  xs={12}
                  sm={5}
                  md={4}
                  lg={3}
                  xl={3}
                >
                  <SupportLeftContainer />
                </Grid>
                <Grid
                  sx={{ height: '100%' }}
                  item
                  xs={12}
                  sm={7}
                  md={8}
                  lg={9}
                  xl={9}
                >
                  <SupportRightContainer />
                </Grid>
              </Grid>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default Support;
